import Tables from 'src/class/Tables';
import i18n from 'src/i18n';

const configTable = () => {
  const Table = { ...Tables.Table };
  Table.tableColumns = [
    {
      prop: 'business.name',
      label: i18n.t('common_words.company'),
      minWidth: 190,
      sortable: true,
    },
    {
      prop: 'number_cycles',
      label: i18n.t('fertilization.cycle_number'),
      minWidth: 150,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'year',
      label: i18n.t('common_words.year'),
      minWidth: 150,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'initial_date',
      label: i18n.t('common_words.initial_date'),
      minWidth: 180,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'end_date',
      label: i18n.t('common_words.final_date'),
      minWidth: 180,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'user_label',
      label: i18n.t('common_words.user'),
      minWidth: 250,
      sortable: true,
    },
  ];

  return { Table };
};

export default configTable;

